import { EditorProps } from 'react-data-grid'

import { memo } from 'react'

import { DgtPdOrderPicklistExtraReturnItem } from '../models'

export default memo(function SelectStLoEditor({ props } : {
  props: EditorProps<DgtPdOrderPicklistExtraReturnItem | null>
}) {
  const { row, onRowChange } = props
  // for CLAIM and REPACK, using WFGR, WFG1, WFG3, WFG4 storage locations
  return <div className='flex items-center justify-center w-full h-full'>
    <select title='select'
      value={row?.returnStorageLocation || '-'}
      className='p-1 border border-gray-400 rounded-md'
      onChange={(e) => {
        let updatedRow = { ...row, returnStorageLocation: e.currentTarget.value } as DgtPdOrderPicklistExtraReturnItem
        onRowChange(updatedRow, true)
      }}
      onKeyDown={(e) => e.stopPropagation()}
    >
      {['-', 'WSH1', 'WSH2', "PKHH", "PKTT", "PK01", "PK02", "WFGR", "WFG1", "WFG3", "WFG4"].map((loc, idx) => <option key={loc} value={loc}>{loc}</option>)}
    </select>
  </div>
})